import { Select, Typography } from 'antd'
import { OptionalValueSetterPair } from 'features/drilldown/utils/valueSetterPair'
import { OntologyRolodexEntryType, useOntology } from 'features/dynamicOntology'
import { FC, useEffect, useMemo } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`

const { Text } = Typography

type SchemaTypeSelectProps = OptionalValueSetterPair<
  OntologyRolodexEntryType,
  'selectedType'
> & { label: string }

// TODO(xdowns): merge this with the schema type select in bulk edit
export const SchemaTypeSelect: FC<SchemaTypeSelectProps> = ({
  selectedType,
  setSelectedType,
  label,
}) => {
  const { entryTypeNames } = useOntology()
  useEffect(
    () =>
      setSelectedType?.((prev) =>
        Object.keys(entryTypeNames).includes(prev)
          ? prev
          : Object.keys(entryTypeNames)[0]
      ),
    [entryTypeNames, setSelectedType]
  )
  const options = useMemo<ReadonlyArray<{ value: string; label: string }>>(
    () =>
      Object.entries(entryTypeNames).map(([type, name]) => ({
        value: type,
        label: name,
      })),
    [entryTypeNames]
  )

  return (
    <Container>
      <Text>{label}: </Text>
      <Select
        style={{ width: '300px' }}
        value={selectedType}
        onChange={setSelectedType}
        disabled={!setSelectedType}>
        {options.map(({ value, label }) => (
          <Select.Option key={value} value={value}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Container>
  )
}
